import { useState } from 'react';
import { ApplicantUserCitizenship, ApplicantUserCitizenshipInput } from '../../../../generated';
import { Country } from '../../../../types/country';
import { Button, Form } from 'antd';
import { MinusCircleOutlined } from '@ant-design/icons';
import { EditProfile } from './edit-profile';
import { CountryDropdownContainer } from '../../../shared/country-dropdown/country-dropdown-container';

const EDIT_TITLE = 'View Citizenship Details';

interface CitizenshipEditProps {
  citizenship: ApplicantUserCitizenship | null | undefined;
  countries: Country[];
  onCancel: () => void;
  onSave: (applicant: ApplicantUserCitizenshipInput) => Promise<void>;
}

export const ProfileCitizenshipEdit: React.FC<CitizenshipEditProps> = ({
  citizenship,
  countries,
  onCancel,
  onSave
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [form] = Form.useForm<ApplicantUserCitizenshipInput>();

  const initalValues = {
    currentCitizenOf: citizenship?.currentCitizenOf
  };

  const selectedCitizenship = Form.useWatch<string[]>('currentCitizenOf', form); 

  const CitizenshipDetialsForm = (
    <Form
      form={form}
      initialValues={initalValues}
      layout="vertical"
      className="w-[85%] md:w-auto"
      onFinish={async (values) => {
        onSave(values);
        setIsSubmitting(true);
      }}
    >
      <Form.Item label="Current Citizen of">
        <Form.List name="currentCitizenOf">
          {(fields, { add, remove }) => {
            return (
              <div>
                {fields.map((field) => {
                  return (
                    <div key={field.key} style={{ marginBottom: '15px' }}>
                      <div
                        style={{
                          display: 'inline-block',
                          verticalAlign: 'top',
                          paddingRight: '10px'
                        }}
                      >
                        {field.key > 0 ? (
                          <MinusCircleOutlined
                            className="dynamic-delete-button"
                            onClick={() => {
                              remove(field.name);
                            }}
                          />
                        ) : null}
                      </div>
                      <div
                        style={{
                          display: 'inline-block',
                          paddingTop: '3px',
                          paddingLeft: '10px',
                          ...(field.key > 0 ? { borderLeft: '1px solid darkgrey' } : {})
                        }}
                      >
                        <Form.Item
                          {...field}
                          validateTrigger={['onChange', 'onBlur']}
                          rules={[
                            {
                              required: true,
                              message: 'Please select field or delete this field.'
                            }
                          ]}
                        >
                          <CountryDropdownContainer
                            isCitizenship={true}
                            placeholder="Country"
                            style={{ width: 200 }}
                            countryData={countries}
                            selectedCitizenship={selectedCitizenship}
                            showSearch
                            optionFilterProp="children"
                            labelRender={(labelInValue) => {
                              const country = labelInValue ? countries.find((c) => c.countryCode === (labelInValue.value as string)) : null;
                              return country ? <span>{country.countryName}</span> : null;
                            }}
                            onChange={(value: string) => {
                              form.setFieldValue(['currentCitizenOf', field.name], value);
                            }}
                          />
                        </Form.Item>
                      </div>
                    </div>
                  );
                })}
                {fields.length < 5 ? (
                  <Form.Item>
                    <Button
                      style={{ width: '90%' }}
                      type="dashed"
                      onClick={() => {
                        const currentCitizenOf = form.getFieldValue(['currentCitizenOf']);
                        if (currentCitizenOf?.some((val: string) => val === undefined)) { 
                          return;
                        }
                        add();
                      }}
                    >
                      Add Additional Citizenship
                    </Button>
                  </Form.Item>
                ) : null}
              </div>
            );
          }}
        </Form.List>
      </Form.Item>

      <div className="flex items-center justify-end gap-4 w-full">
        <Button onClick={onCancel} disabled={isSubmitting}>
          Cancel
        </Button>
        <Button htmlType="submit" value={'save'} type="primary">
          Save
        </Button>
      </div>
    </Form>
  );

  return <EditProfile title={EDIT_TITLE} form={CitizenshipDetialsForm} />;
};
